import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

const {
  useGet: useCirrWorkAuthorizations,
  useCreate: useCreateCirrWorkAuthorizations,
  useUpdate: useUpdateCirrWorkAuthorizations,
} = getCRUDHooks({
  entityName: 'cirrWorkAuthorizations',
  get: ({ userId, pathId }) =>
    clientApi
      .getOCClient()
      .helpers.user.users.id(userId)
      .paths.id(pathId)
      .workAuthorizations.find(),
  create: ({ userId, pathId, values }) =>
    clientApi
      .getOCClient()
      .helpers.user.users.id(userId)
      .paths.id(pathId)
      .workAuthorizations.create(values),
  update: (values, { userId, pathId }) =>
    clientApi
      .getOCClient()
      .helpers.user.users.id(userId)
      .paths.id(pathId)
      .workAuthorizations.update('', values),
});

export {
  useCirrWorkAuthorizations,
  useCreateCirrWorkAuthorizations,
  useUpdateCirrWorkAuthorizations,
};
